import { MergeElementProps } from '@/lib/core/interfaces/common.types'

import { StyledRadiomark } from './Radiomark.styles'

export type RadiomarkElementProps = MergeElementProps<
  'span',
  {
    isActive: boolean
  }
>

export const RadiomarkComponent = ({ ...props }: RadiomarkElementProps) => (
  <StyledRadiomark aria-hidden="true" {...props} />
)
